import axios from '@/api/$axios'
export default {
  getSMSCode ({ mobile }) {
    return axios.post(`/sms_codes`, {
      mobile
    })
  }
}
